<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.26</b> - Small balance changes & AI fixes</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Balance
        <ul>
          <li>- Devil Mask</li>
          <ul>
            <li class="pl-4">* AP cost: <code>10</code> --> <code>40</code></li>
            <li class="pl-4">
              * MP cost: <code>30 + L*3</code> -->
              <code>30 + L*5</code>
            </li>
            <li class="pl-4">* Effect range: <code>1 + L/5</code> --> <code>2</code></li>
          </ul>
          <li>
            - Poison Weapon potency: <code>20 + L*(Le/15)</code> -->
            <code>20 + L*(Le/5)</code>
          </li>
        </ul>
      </li>
      <li>
        AI
        <ul>
          <li>- Fixed a bug where Devil Mask could be cast with no enemies in range</li>
          <li>- For healing, heroes will now only target heroes in PvP</li>
          <li>- For buffs, units will now start with the closest unbuffed allies</li>
          <li>- Similarly, Suture will now target the closest ally who needs it</li>
          <li>- Units will no longer use Leap/Teleport while feared</li>
        </ul>
      </li>
      <li>Options on poppets can now deal damage</li>
    </ul>
  </div>
</template>
